import React from "react";
import { Squares2X2Icon } from "@heroicons/react/24/outline";
import { ModuleI } from "../../../types";

interface ModulesTabContentProps {
  modules: ModuleI[];
  selectedModuleId: string | null;
  onSelectModule: (module: ModuleI) => void;
}

const ModulesTabContent: React.FC<ModulesTabContentProps> = ({
  modules,
  selectedModuleId,
  onSelectModule,
}) => {
  if (modules.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">No modules found</div>
    );
  }

  return (
    <div className="divide-y">
      {modules.map((module: ModuleI) => (
        <div
          key={module._id}
          className={`p-4 cursor-pointer hover:bg-gray-50 transition-colors ${
            selectedModuleId === module._id
              ? "bg-blue-50 border-l-4 border-blue-500"
              : ""
          }`}
          onClick={() => onSelectModule(module)}
        >
          <div className="flex items-center gap-3">
            {module.icon?.src ? (
              <img
                src={module.icon.src}
                alt={module.icon.alt || module.title}
                className="w-8 h-8 object-contain"
              />
            ) : (
              <Squares2X2Icon className="w-8 h-8 text-gray-400" />
            )}
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm truncate">{module.title}</p>
              <p className="text-xs text-gray-500">
                {module.lessons?.length || 0} lesson
                {module.lessons?.length !== 1 ? "s" : ""}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ModulesTabContent;
